const normalizePath = (path = '/') => (path.startsWith('/') ? path : `/${path}`);

const cleanObject = (value = {}) => Object.fromEntries(Object.entries(value).filter(([, entryValue]) => entryValue !== null && entryValue !== undefined && String(entryValue).trim() !== ''));

export function buildInternalAppHref(path = '/') {
    return `/app${normalizePath(path)}`;
}

const normalizeChartingRouteType = (type = '') => {
    const normalizedType = String(type || '').trim();

    if (!normalizedType || normalizedType === 'home' || normalizedType === 'finder') {
        return 'finder';
    }

    return normalizedType;
};

export function buildChartingRoutePath({ type = 'finder', value = '', query = {} } = {}) {
    const normalizedType = normalizeChartingRouteType(type);
    const normalizedValue = String(value || '').trim();
    let path = '/graficador-next';

    if (normalizedType !== 'finder') {
        path += `/${encodeURIComponent(normalizedType)}`;
    }

    if (normalizedValue) {
        path += `/${encodeURIComponent(normalizedValue)}`;
    }

    const params = new URLSearchParams(cleanObject(query)).toString();

    return params ? `${path}?${params}` : path;
}

export function buildChartingAppHref(options = {}) {
    return buildInternalAppHref(buildChartingRoutePath(options));
}

export function buildChartingRouteLocation({ type = 'finder', value = '', query = {} } = {}) {
    const normalizedType = normalizeChartingRouteType(type);

    if (normalizedType === 'finder') {
        return {
            name: 'ChartingNext',
            query: cleanObject(query)
        };
    }

    return {
        name: 'ChartingNextEntry',
        params: {
            entryType: normalizedType,
            ...(value ? { entryValue: value } : {})
        },
        query: cleanObject(query)
    };
}

export function buildChartingLegacyHref(options = {}) {
    const legacyPath = buildChartingRoutePath(options).replace(/^\/graficador-next/, '/app/graficador-dinamico');
    const apiOrigin = String(process.env.VUE_APP_API || '').replace(/\/+$/, '');

    return apiOrigin ? `${apiOrigin}${legacyPath}` : legacyPath;
}
